import React from 'react';
import {
  AfterSubmitFunc,
  Button,
  ButtonColor,
  ButtonVariant,
  DateInput,
  FormTemplate,
  IconType,
  TextInput
} from 'ui-builder';
import { ApiToken, CreateTokenRequest, useApiTokensService } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';

export function CreateApiTokenForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const apiTokensService = useApiTokensService();

  return (
    <FormTemplate<CreateTokenRequest, ApiToken>
      title="Create API Token"
      submitFormFunc={async (data) => {
        return await apiTokensService.createToken(data);
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
            maxLength: 40,
          },
        },
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="name" label="Token Name" />
      <DateInput source="expiresAt" label="Expires At" />
    </FormTemplate>
  );
}

export function CreateApiTokenButton() {
  const popupFormManager = usePopupFormManager();

  return (
    <Button
      text="Create Token"
      onClick={() => popupFormManager.openForm(<CreateApiTokenForm />)}
      color={ButtonColor.BLUE}
      variant={ButtonVariant.FILLED}
      iconType={IconType.PLUS}
    />
  );
}
